import { ComparableBoatData, useGetActiveCarouselItem } from '@components/CompareBoats/hooks/useCompare';
import { Grid } from 'antd';
import { KeenSliderPlugin, useKeenSlider } from 'keen-slider/react';
import { FC, useEffect } from 'react';
import styles from '../CompareTable.module.scss';
import PanelDataItem from './PanelDataItem.component';

interface StorageSpecsPanelDataInterface {
  boatComparableData: ComparableBoatData[];
}
const MutationPlugin: KeenSliderPlugin = (slider) => {
  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      slider.update();
    });
  });

  const config = { childList: true };

  slider.on('created', () => {
    observer.observe(slider.container, config);
  });
  slider.on('destroyed', () => {
    observer.disconnect();
  });
};

const StorageSpecsPanelData: FC<StorageSpecsPanelDataInterface> = ({ boatComparableData }) => {
  const activeCarouselItem = useGetActiveCarouselItem();

  const { md } = Grid.useBreakpoint();

  const [ref, instanceRef] = useKeenSlider<HTMLDivElement>(
    {
      drag: false,
      slides: {
        perView: 7,
      },
      breakpoints: {
        '(max-width: 1440px)': {
          slides: { perView: 6 },
        },
        '(max-width: 1200px)': {
          slides: { perView: 5 },
        },
        '(max-width: 1024px)': {
          slides: { perView: 4 },
        },
        '(max-width: 992px)': {
          slides: { perView: 3 },
        },
        '(max-width: 768px)': {
          slides: { perView: 2 },
        },
        '(max-width: 520px)': {
          slides: { perView: 2 },
        },
      },
    },
    [MutationPlugin],
  );

  useEffect(() => {
    instanceRef?.current?.moveToIdx(activeCarouselItem);
  }, [activeCarouselItem, instanceRef]);

  const storageSpecsList: { specLabel: string; specId: number; noDataSpec?: boolean }[] = [
    { specLabel: 'Fuel tank', specId: 78, noDataSpec: true },
    { specLabel: 'Fuel tank A', specId: 79 },
    { specLabel: 'Water tank', specId: 80, noDataSpec: true },
    { specLabel: 'Water tank A', specId: 81 },
    { specLabel: 'Holding tank', specId: 82, noDataSpec: true },
    { specLabel: 'Holding tank A', specId: 83 },
    { specLabel: 'Water heater', specId: 84, noDataSpec: true },
    { specLabel: 'Water heater A', specId: 85 },
  ];

  return (
    <div className={styles.specsPanelDataContainer}>
      <div style={md ? { width: 192 } : { width: '100%' }}>
        {storageSpecsList.map((mainSpecItem) => (
          <div key={mainSpecItem.specId}>
            <div className={mainSpecItem?.noDataSpec ? styles.noDataSpecsNamesStyles : styles.specsNamesStyles}>
              {mainSpecItem.specLabel}
            </div>
            {mainSpecItem?.specId === 79 &&
              !md &&
              boatComparableData?.map((boat) => (
                <PanelDataItem panelData={boat?.fuelTanks?.at(0)?.capacity} panelDataType="text" key={boat?._id} />
              ))}
            {mainSpecItem?.specId === 81 &&
              !md &&
              boatComparableData?.map((boat) => (
                <PanelDataItem panelData={boat?.waterTanks?.at(0)?.capacity} panelDataType="text" key={boat?._id} />
              ))}
            {mainSpecItem?.specId === 83 &&
              !md &&
              boatComparableData?.map((boat) => (
                <PanelDataItem panelData={boat?.holdingTanks?.at(0)?.capacity} panelDataType="text" key={boat?._id} />
              ))}
            {mainSpecItem?.specId === 85 &&
              !md &&
              boatComparableData?.map((boat) => (
                <PanelDataItem panelData={boat?.waterHeaters?.at(0)?.capacity} panelDataType="text" key={boat?._id} />
              ))}
          </div>
        ))}
      </div>

      {md && (
        <div ref={ref} className="keen-slider">
          {boatComparableData?.map((boat) => (
            <div key={boat._id} className="keen-slider__slide">
              <PanelDataItem panelData={''} panelDataType="empty" />
              <PanelDataItem panelData={boat?.fuelTanks?.at(0)?.capacity} panelDataType="text" />
              <PanelDataItem panelData={''} panelDataType="empty" />
              <PanelDataItem panelData={boat?.waterTanks?.at(0)?.capacity} panelDataType="text" />
              <PanelDataItem panelData={''} panelDataType="empty" />
              <PanelDataItem panelData={boat?.holdingTanks?.at(0)?.capacity} panelDataType="text" />
              <PanelDataItem panelData={''} panelDataType="empty" />
              <PanelDataItem panelData={boat?.waterHeaters?.at(0)?.capacity} panelDataType="text" />
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default StorageSpecsPanelData;
